import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';

import { translate } from 'helpers/intl';
import ContainerTabs from 'components/ContainerTabs';
import Breadcrumbs from 'components/Breadcrumbs';
import CompensationServices from 'containers/AutoDetailsPage/CompensationServices';
import {
  StyledMediumSectionHeader,
  StyledCaptions,
} from 'containers/AutoDetailsPage/styles';
import {
  getAutoDetailsPageBreadcrumbsPathSelector,
  getAutoDetailsPageSelectedTabValue,
  getAutoFaqSelector,
} from 'store/global/selectors';
import { getContractAutoSelector } from 'store/contract/selectors';
import { breadcrumbsItemType } from 'store/global/types';
import {
  setAutoDetailsPageBreadcrumbsPath,
  getFaq,
} from 'store/global/actions';
import messages from 'containers/AutoDetailsPage/messages';
import FrequentlyAskedQuestions from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions';
import MyContractAndGarantiesTab from 'containers/AutoDetailsPage/MyContractAndGarantiesTab';
import ServicesBloc from 'containers/AutoDetailsPage/ServicesBlock';
import SuivreSinitreTab from 'containers/AutoDetailsPage/SuivreSinistreTab';
import MyOffers from 'containers/AutoDetailsPage/MyOffers';
import { getDetailContract } from 'store/contract/actions';
import DetailPageLayout from 'components/DetailPageLayout';
import HeaderImage from 'images/header-img.png';
import { StyledShortBody } from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions/styles';
import { sanlamDarkBlue } from 'Material-UI/colors';
import { getRolesUserSelector } from 'store/user/selectors';
import PAGES from 'routes/pages';
import { getContractsAuto } from 'store/contract/actions';
import { getSinistres } from 'store/sinistre/actions';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import CompensationServicesPage from 'containers/CompensationServicesPage/index';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

const tabItems = [
  {
    label: 'suiviDeSinistre',
    content: <SuivreSinitreTab />,
  },
  {
    label: 'contractEtGarantie',
    content: <MyContractAndGarantiesTab />,
  },
];

const AutoDetailsPage = (props: {
  detailsPageBreadcrumbsPath: breadcrumbsItemType[];
  setAutoDetailsPageBreadcrumbsPath: Function;
  contractsAuto: any;
  intl: IntlShape;
  getDetailContract: Function;
  selectedTabValue: number;
  getContractsAuto: Function;
  getSinistres: Function;
  getFaq: Function;
  faqAuto: [];
}) => {
  const language = useSelector(getLocaleSelector);

  useEffect(() => {
    props.getSinistres();
    props.getContractsAuto();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    props.getFaq(language);
    // eslint-disable-next-line
  }, [language]);

  const firstContractPolicyNumber = get(
    props.contractsAuto,
    '[0].contractNumber',
  );
  const firstContractCirculationDate = get(
    props.contractsAuto,
    '[0].circulationDate',
  );

  useEffect(() => {
    props.getDetailContract({
      policyNumber: firstContractPolicyNumber,
      circulationDate: firstContractCirculationDate,
    });
    // eslint-disable-next-line
  }, [firstContractPolicyNumber, firstContractCirculationDate, language]);

  const HeaderTextBloc = (
    <>
      <StyledMediumSectionHeader>
        {translate(get(messages, 'title'), props)}
      </StyledMediumSectionHeader>
      <StyledCaptions>
        {translate(get(messages, 'subTitle'), props)}
      </StyledCaptions>
    </>
  );
  const rootPath = [
    { name: 'auto', route: PAGES.AUTODASHBOARD },
    {
      name:
        props.selectedTabValue === 0 ? 'suiviDeSinistre' : 'contractEtGarantie',
      route: PAGES.AUTO_DETAILS,
    },
  ];
  return (
    <DetailPageLayout
      headerImage={HeaderImage}
      HeaderTextBloc={HeaderTextBloc}
      Breadcrumbs={
        <Breadcrumbs
          path={props.detailsPageBreadcrumbsPath}
          setBreadcrumbsPath={props.setAutoDetailsPageBreadcrumbsPath}
        />
      }
      TabsBloc={
        props.selectedTabValue === 2 ? (
          <CompensationServicesPage />
        ) : (
          <ContainerTabs
            tabItems={tabItems}
            setBreadcrumbsPath={props.setAutoDetailsPageBreadcrumbsPath}
            rootPath={[{ name: 'auto', route: PAGES.AUTODASHBOARD }]}
            selectedTabValue={props.selectedTabValue}
          />
        )
      }
      FAQBloc={
        <FrequentlyAskedQuestions
          items={
            props.faqAuto &&
            props.faqAuto.map(
              (
                item: { question: string; code: string; id: number },
                index: number,
              ) => ({
                title: (
                  <StyledShortBody
                    weight="bold"
                    color={sanlamDarkBlue}
                    key={index}
                  >
                    {item.question}
                  </StyledShortBody>
                ),
                path: '/faq',
                id: item.id,
                code: item.code,
                isFaq: true,
              }),
            )
          }
          GACategoryAllResponses={EVENT_CATEGORIES.AUTO_DETAILS}
        />
      }
      CompensationServicesBloc={
        props.selectedTabValue === 2 ? (
          <></>
        ) : (
          <CompensationServices
            rootPath={rootPath}
            setBreadcrumbsPath={props.setAutoDetailsPageBreadcrumbsPath}
          />
        )
      }
      ServiceBloc={<ServicesBloc />}
      MyOffersBloc={<MyOffers />}
    />
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    detailsPageBreadcrumbsPath: breadcrumbsItemType[];
    contractsAuto: any;
    roles: any;
    selectedTabValue: number;
    faqAuto: [];
  }
>({
  contractsAuto: getContractAutoSelector,
  roles: getRolesUserSelector,
  detailsPageBreadcrumbsPath: getAutoDetailsPageBreadcrumbsPathSelector,
  selectedTabValue: getAutoDetailsPageSelectedTabValue,
  faqAuto: getAutoFaqSelector,
});
const mapDispatchToProps = {
  setAutoDetailsPageBreadcrumbsPath,
  getDetailContract,
  getContractsAuto,
  getSinistres,
  getFaq,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AutoDetailsPage));
export { AutoDetailsPage as AutoDetailsPageTest };
